import React from "react"
import { useParams } from "react-router-dom"
import {
  Button,
  Table,
  Thead,
  Tbody,
  Td,
  Tr,
  TableContainer,
  Box,
  Th,
} from "@chakra-ui/react"
import { AddIcon } from "@chakra-ui/icons"
import { Datasets, Schemas, DatasetSchemas } from "../lib/store"
import Link from "./Link"

export default function DatasetDetail() {
  // Global state
  const [datasets] = Datasets.useState()
  const [schemas] = Schemas.useState()
  const [datasetSchemas] = DatasetSchemas.useState()

  // Path params
  const { datasetId } = useParams()

  // What to display
  const [dataset, setDataset] = React.useState({})
  const [schemasList, setSchemasList] = React.useState([])

  // Pick the dataset and the schemas that belong to it
  React.useEffect(() => {
    setDataset(datasets[datasetId])
    setSchemasList((datasetSchemas[datasetId] || []).map((id) => schemas[id]))
  }, [datasetId, datasets, schemas, datasetSchemas])

  console.debug("Rendering DatasetDetail", {
    datasetId,
    dataset,
    schemasList,
    datasets,
    schemas,
    datasetSchemas,
  })

  return (
    <Box
      display="flex"
      flexDir="column"
      height="100%"
      p="0em 2em 0em 2em"
      gap="1em"
    >
      <Link to={`/datasets/${datasetId}/schemas/create`} ml="auto">
        <Button
          variant="primary"
          rightIcon={<AddIcon />}
          id="btn-schema-new"
          title="Create a schema"
          size={{ base: "sm", md: "md" }}
        >
          Create Schema
        </Button>
      </Link>
      <TableContainer
        borderRadius="0.5em"
        boxShadow="lg"
        overflowY="auto"
        bg="white"
        overflow="visible"
      >
        <Table>
          <Thead>
            <Tr>
              <Th>Schema</Th>
              <Th>Fields</Th>
            </Tr>
          </Thead>
          <Tbody>
            {schemasList.map((row, index) => (
              <Tr key={index}>
                <Td>
                  <Link
                    to={`/datasets/${datasetId}/schemas/${row.id}`}
                    variant="underline"
                    textDecoration="underline"
                  >
                    {row.name}
                  </Link>
                </Td>
                <Td>
                  {(row.schema?.properties &&
                    Object.keys(row.schema.properties).length) ||
                    "Unknown"}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}
